import { NgModule } from '@angular/core';
import { Ng2SmartTableModule } from "ng2-smart-table";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "../material.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MenuItems } from './menu-items/menu-items';
import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective
} from './accordion';
import { SmartTableComponent } from './smart-table/smart-table.component';
import { ConfirmPopupComponent } from './popups/confirm-popup/confirm-popup.component';
import { DatePipe } from '../util/pipes/date.pipe';
import { SafeHtmlPipe } from '../util/pipes/safe-html.pipe';
import { SortDataPipe } from '../util/pipes/sort-data.pipe';
import { LoaderComponent } from './loader/loader.component';
import { SafePipe } from '../util/pipes/safe.pipe';
import { LoaderWihMessagesComponent } from './loader-wih-messages/loader-wih-messages.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddDashboardComponent } from './component/add-dashboard/add-dashboard.component';
import { SummaryComponent } from '../patients/summary/summary.component';
import { AddPatientComponent } from '../patients/add-patient/add-patient.component';
import { SurveyComponent } from '../patients/survey/survey.component';
import { AppointmentListComponent } from '../patients/appointment/appointment-list/appointment-list.component';
import { BookAppointmentPopupComponent } from '../patients/appointment/book-appointment-popup/book-appointment-popup.component';
import { DocumentsComponent } from '../patients/documents/documents.component';
import { ActivitiesComponent } from '../patients/activities/activities.component';
import { LabelComponent } from './component/label/label.component';
import { PatientEngagementComponent } from '../patients/patient-engagement/patient-engagement.component';
import { PatientDetailComponent } from '../patients/patient-detail/patient-detail.component';
import { ChatBubbleComponent } from '../patients/chat-bubble/chat-bubble.component';
import { WorkflowComponent } from '../patients/workflow/workflow.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { SearchComponent } from '../dashboard/search/search.component';
import { AdvanceSearchComponent } from '../dashboard/advance-search/advance-search.component';
import { AvatarModule } from 'ngx-avatar';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { InvoiceTemplatesPopupComponent } from './component/invoice-templates-popup/invoice-templates-popup.component';
import { NgxPrintModule } from 'ngx-print';
import { TemplateComponent } from './component/template/template.component';
import { EmailTemplatesPopupComponent } from './component/email-templates-popup/email-templates-popup.component';
import { CustomTemplateInputComponent } from './component/template/custom-template-input/custom-template-input.component';
import { MessageContainerComponent } from './component/message-container/message-container.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UploadDocumentsComponent } from './component/upload-documents/upload-documents.component';
import { FileUploadModule } from "ng2-file-upload";
import { SortTaskPipe } from '../util/pipes/sort-task.pipe';
import { MovePatientPopupComponent } from '../dashboard/move-patient-popup/move-patient-popup.component';
import { PrintCustomDataPopupComponent } from './component/print-custom-data-popup/print-custom-data-popup.component';
/**
 * This module contains all the components which are shared in the app. Basically, these are the reusable components throughout the app
 */
@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    SmartTableComponent,
    DatePipe,
    SafeHtmlPipe,
    SortDataPipe,
    ConfirmPopupComponent,
    LoaderComponent,
    SafePipe,
    LoaderWihMessagesComponent,
    AddDashboardComponent,
    SummaryComponent,
    SurveyComponent,
    AppointmentListComponent,
    BookAppointmentPopupComponent,
    DocumentsComponent,
    PatientEngagementComponent,
    SearchComponent,
    AdvanceSearchComponent,
    ActivitiesComponent,
    LabelComponent,
    InvoiceTemplatesPopupComponent,
    TemplateComponent,
    EmailTemplatesPopupComponent,
    CustomTemplateInputComponent,
    AddPatientComponent,
    PatientDetailComponent,
    ChatBubbleComponent,
    MessageContainerComponent,
    WorkflowComponent,
    UploadDocumentsComponent,
    SortTaskPipe,
    MovePatientPopupComponent,
    PrintCustomDataPopupComponent
  ],
  imports: [
    Ng2SmartTableModule,
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    AvatarModule,
    NgxSkeletonLoaderModule,
    NgxPrintModule,
    InfiniteScrollModule,
    FileUploadModule
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    SmartTableComponent,
    ConfirmPopupComponent,
    DatePipe,
    SafeHtmlPipe,
    SortDataPipe,
    LoaderComponent,
    SafePipe,
    LoaderWihMessagesComponent,
    SummaryComponent,
    SurveyComponent,
    AppointmentListComponent,
    BookAppointmentPopupComponent,
    DocumentsComponent,
    PatientEngagementComponent,
    SearchComponent,
    AdvanceSearchComponent,
    ActivitiesComponent,
    LabelComponent,
    TemplateComponent,
    AddPatientComponent,
    PatientDetailComponent,
    ChatBubbleComponent,
    MessageContainerComponent,
    WorkflowComponent,
    SortTaskPipe,
    MovePatientPopupComponent,
    PrintCustomDataPopupComponent
  ],
  providers: [
    DatePipe,
    SafeHtmlPipe,
    SortDataPipe,
    MenuItems,
    SortTaskPipe
  ],
  entryComponents: [
    ConfirmPopupComponent, 
    BookAppointmentPopupComponent, 
    LabelComponent, 
    CustomTemplateInputComponent, 
    AddPatientComponent,
    PatientDetailComponent,
    MessageContainerComponent,
    UploadDocumentsComponent,
    MovePatientPopupComponent,
    PrintCustomDataPopupComponent
  ],
})
export class SharedModule {}
